import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const COGNITO_DOMAIN =
  "https://us-east-1elqlibp38.auth.us-east-1.amazoncognito.com";
const CLIENT_ID = "4tls70cf96vr6fjci4navi8abn";
const REDIRECT_URI =
  "https://staging.d27oe0crm68bdu.amplifyapp.com/admin/callback";

export default function AdminCallback() {
  const nav = useNavigate();
  const [msg, setMsg] = useState("🔄 Admin Login wird abgeschlossen …");
  const [err, setErr] = useState("");

  useEffect(() => {
    const run = async () => {
      try {
        const url = new URL(window.location.href);

        const code = url.searchParams.get("code");
        const oauthError = url.searchParams.get("error");
        const oauthErrorDesc = url.searchParams.get("error_description");

        if (oauthError) {
          throw new Error(`OAuth error: ${oauthError} ${oauthErrorDesc || ""}`.trim());
        }

        if (!code) {
          throw new Error("Kein OAuth code gefunden (callback ohne ?code=...)");
        }

        setMsg("✅ Code erhalten – tausche gegen Tokens …");

        const body = new URLSearchParams();
        body.set("grant_type", "authorization_code");
        body.set("client_id", CLIENT_ID);
        body.set("code", code);
        body.set("redirect_uri", REDIRECT_URI);

        const res = await fetch(`${COGNITO_DOMAIN}/oauth2/token`, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: body.toString(),
        });

        const raw = await res.text();
        if (!res.ok) {
          throw new Error(`Token exchange failed (${res.status}): ${raw}`);
        }

        const tokens = JSON.parse(raw);

        if (!tokens.id_token || !tokens.access_token) {
          throw new Error(`Unerwartete Token Response: ${raw}`);
        }

        localStorage.setItem("admin_id_token", tokens.id_token);
        localStorage.setItem("admin_access_token", tokens.access_token);
        if (tokens.refresh_token) localStorage.setItem("admin_refresh_token", tokens.refresh_token);

        setMsg("✅ Tokens gespeichert – weiter zum Admin Dashboard …");
        nav("/admin", { replace: true });
      } catch (e) {
        setErr(e?.message || String(e));
      }
    };

    run();
  }, [nav]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      {err ? (
        <div className="max-w-3xl w-full bg-red-50 border border-red-200 rounded-xl p-4 text-red-800">
          <div className="font-semibold mb-2">❌ Admin Callback Fehler</div>
          <div className="text-sm whitespace-pre-wrap">{err}</div>

          <div className="mt-3 text-xs text-red-700">
            Tipp: Prüfe Cognito Callback URL & Standard-Redirect müssen exakt mit REDIRECT_URI matchen.
          </div>

          <button
            className="mt-4 px-4 py-2 rounded-lg bg-black text-white"
            onClick={() => (window.location.href = "/admin/login")}
          >
            Zurück zum Login
          </button>
        </div>
      ) : (
        <div className="text-gray-700">{msg}</div>
      )}
    </div>
  );
}